// extracted by mini-css-extract-plugin
export default {"alert":"AlertComponent_alert__g95-5","mobileLink":"AlertComponent_mobileLink__B3FxH"};